
import _ from 'lodash';
import moment from 'moment';
import {mapState, mapActions, mapMutations, mapGetters} from 'vuex';

export default {
	name: 'ChatFriend',
	data () {
		return {
			keyword: '',
			mydebounce: null,
			foundUsers: [], // CID, USERNAME, EMAIL, STATUS
			loading: false,
			isSearch: false,
			foundRooms: [],
			searchStatus: 'COMPLETED', // LOADING, COMPLETED, NOT_FOUND
		}
	},
	computed: {
		...mapState({
			cid: state => state.chatapp.cid,
			name: state => state.chatapp.name,
			email: state => state.chatapp.email,

			roomList: state => state.chatapp.roomList,
			selectedRoom: state => state.chatapp.selectedRoom,
			tempRoom: state => state.chatapp.tempRoom,

			inputText: state => state.chatapp.inputText,
			pageName: state => state.chatapp.pageName,
			inputTextSignal: state => state.chatapp.inputTextSignal,
		}),
		...mapGetters({
			globalRoom: 'chatapp/globalRoom',
			privateRoomList: 'chatapp/privateRoomList',
			groupRoomList: 'chatapp/groupRoomList',
			contentH: 'chatapp/contentH',
			sidebarW: 'chatapp/sidebarW',
		}),
	},
	mounted() {
		// this.initDebounce();
        // window.addEventListener("resize", this.resizeWindow);
        // this.resizeWindow();
	},
    // destroyed() {
        // window.removeEventListener("resize", this.resizeWindow);
	// },
	methods: {
		...mapActions({
			removeUserData: 'chatapp/removeUserData',
		}),
		...mapMutations({
			resetTempRoom: 'chatapp/resetTempRoom',
			resetSelectedRoom: 'chatapp/resetSelectedRoom',
			setSelectedRoom: 'chatapp/setSelectedRoom',
			setRoomList: 'chatapp/setRoomList',
			updateRoom: 'chatapp/updateRoom',
			addRoom: 'chatapp/addRoom',
			setMessageList: 'chatapp/setMessageList',
			addMessage: 'chatapp/addMessage',
			removeMessage: 'chatapp/removeMessage',
			setPageName: 'chatapp/setPageName',
			setTempRoom: 'chatapp/setTempRoom',
		}),
		initDebounce() {
			this.mydebounce = _.debounce(() => {
				if (_.trim(this.keyword).length < 1) return;
				
				this.searchStatus = 'LOADING';
				this.loading = true;
				this.$socket.emit('searchList', {clientCid: this.cid, keyword: this.keyword}, (data) => {
					console.log('CB searchList', data);
					if (!data.isok) {
						_.delay(() => {
							this.searchStatus = 'NOT_FOUND';
						}, 500);
						return;
					}

					_.delay(() => {
						this.searchStatus = (data.items.length > 0) ? 'COMPLETED' : 'NOT_FOUND';
						this.loading = false;
						this.foundUsers = data.items;
					}, 500);
				});
			}, 500);
		},
		onSelectTab(tab){
			switch(tab){
				case "personal": 
					this.resetTempRoom();
					this.resetSelectedRoom();
					this.setMessageList([]);
					break;
				case "group": 
					this.clickRoomButton(this.groupRoomList[0]);
					break;
				case "public": 
					this.clickRoomButton(this.globalRoom);
					break;
			}
		},
		clickRoomButton(room) {
			if(this.selectedRoom && this.selectedRoom.roomCid == room.roomCid) return;

			this.setSelectedRoom(room);
			const roomCid = this.selectedRoom.roomCid;
			const messageCid = '';
			this.$socket.emit('getMoreMessages', {clientCid: this.cid, roomCid, messageCid}, (data) => {
				console.log('CB getMoreMessages', data);
			// this.$socket.emit('getMessages', {clientCid: this.cid, roomCid}, (data) => {
				// console.log('CB getMessages', data)
				if (!data.isok) return;

				// 1. UPDATE MESSAGE LIST
				this.setMessageList(data.items);
				// 2. UPDATE UNREAD MESSAGE COUNT
				this.updateUnreadMessageCount(room.roomCid, true);
				// 3. REDIRECT TO MESSAGE PAGE
				this.setPageName('/MESSAGE');
				// 4. FOCUS TEXT INPUT
				this.$signals.signal.emit('focusInput', {instance: 1});
			});
		},
		updateUnreadMessageCount(roomCid, currentOpen) {
			const clientCid = this.cid;
			this.$socket.emit('updateRoom', {clientCid, roomCid, currentOpen}, (data) => {
				console.log('CB updateRoom', data);
				if (!data.isok) return;

				const {roomCid, unread} = data.item;
				const index = _.findIndex(this.roomList, {roomCid});
				if (index < 0) return;
				const obj = {
					...this.roomList[index]
				};
				console.log('obj', obj);
				obj.unread = unread;
				this.updateRoom(obj);

				// this.setRoomList(roomList);
			});
		},

		clickCancelButton() {
			this.keyword = '';
			this.isSearch = false;
			this.searchStatus = '';

		},
		clickAddRoomButton(room) {
			console.log('room', room);

			// 1 REMOVE <SELECTED_ROOM>
			this.resetSelectedRoom();

			// 2 SET TEMP ROOM
			this.setTempRoom(room);

			// 3. TEXT INPUT FOCUS 
			// this.inputText.focus();
			this.$signals.signal.emit('focusInput', {instance: 1});

			// 4 EMPTY INPUT TEXT AND FOCUS
			this.keyword = '';
			this.isSearch = false;
			this.searchStatus = '';

			// 5. EMPTY MESSAGES LIST
			this.setMessageList([]);
		},
		convertHumanDateTime(value) {
			if (value == '' || value == undefined) return '';
			const datenow = moment();
			const mome = moment(value, "YYYY-MM-DD hh:mm:ss A"); // 2023-10-04 05:47 PM
			// const mome = moment(value, moment.ISO_8601); // 2010-01-01T05:06:07
			const dd = datenow.diff(mome, 'minutes');
			if (dd < 1440) {		
				return mome.format('h:mm a');// WITHIN 24 HOURS
			} else if (dd < 10080) {
				return mome.format('dddd');// WITHIN 1 WEEK
			} else {
				return mome.format('L');
			}
		},
		searchUser(){
			if(this.keyword){
				this.$socket.emit('searchList', {clientCid: this.cid, keyword: this.keyword}, (data) => {
					console.log('CB searchList', data);
					if(data.items.length > 0){
						const item = data.items[0];
						if(item.email == this.email){
							this.resetTempRoom();
							this.resetSelectedRoom();
						}else{
							const roomIndex = _.findIndex(this.privateRoomList, { roomUserCid: item.cid });
							console.log(roomIndex, item.cid, this.privateRoomList.map(a => a.roomUserCid))
							if(roomIndex > -1){
								this.clickRoomButton(this.privateRoomList[roomIndex]);
							}else{
								this.clickAddRoomButton(item);
							}
						}
					}else{
						this.$swal({ icon: "info", title: "The e-mail you have entered is not associated with a valid user."});
					}
					this.keyword = '';
				});
			}
		}
	},
	watch: {
		// keyword(newvalue, oldvalue) {
		// 	const len = _.trim(newvalue).length;
		// 	if (len > 2) {
		// 		this.isSearch = true;
		// 		this.mydebounce();
		// 	} else if (len == 0) {
		// 		this.isSearch = false;
		// 	} else {
		// 		this.foundUsers.splice(0, this.foundUsers.length);
		// 	}
		// },
	},
}
